export default "__VITE_ASSET__CgvshzwC__"